export default __webpack_public_path__ + "static/media/Essential Blocks.fed14d8c.svg";